import React from 'react';
import '../css/Header.css'

function Header({ title, logo }) {
  return (
    <div className="contHeader">
      <header>
        {logo && <img src={require("../assets/img/Enginios logo.png")} alt=""/>}
        <h1>{title}</h1><br/>
      </header>
    </div>
  );
};

export default Header